/** Full page reload after assume or release. Split out so tests can mock it. */
export function reloadPage(): void {
  window.location.reload();
}
